/**
 * **A04 · The incident card and the lost-child card** (Stream A, Paper.dc.html), laid out by the
 * `field_papers` engine: what the field app records, on paper, for the night it does not open —
 * two 4×6 cards, every field a label and a line. The security channel and Dispatch's number come
 * from the year's radio plan (`GET /ops/radio-plan`, WORKLIST ops-new); until Festival Ops serves
 * it they print NO DATA. Scored against the drawing by walk 99g.
 */
import type { ReactNode } from 'react';
import { fieldCards, type RadioPlan } from '@cider/domain/engines';
import { useLoad } from '../views/money/shared.js';
import { usePrinted } from './printed.js';
import { DrawnPages } from './drawn-doc.js';

export function FieldCards({ year }: { year: string }): ReactNode {
  const plan = useLoad<RadioPlan>(`/ops/radio-plan?year=${year}`);
  const ready = plan.data !== null || plan.error !== null;
  usePrinted('field-cards', ready, { year: Number(year) });
  if (!ready) return <p>Reading the radio plan…</p>;
  return <DrawnPages pages={fieldCards(plan.data)} stamp="time" />;
}
